export default "__VITE_ASSET__KRad1bu4__"